<template>
  <section class="referral-card d-flex flex-column col-xs-12 py-4">
    <h6 class="text-white mt-2">
      {{ $t('UserProfile.ReferralCard.Title') }}
    </h6>
    <b-input :value="referUrl" class="mt-3" dir="ltr" />
  </section>
</template>

<script>
export default {
  name: 'UserProfileNewUserReferral',
  props: {
    referUrl: String
  }
}
</script>
